import React from 'react';
export function HeroSection({
  currentPriceType
}) {
  return <div className="mb-8" data-id="element-107">
      <h1 className="text-4xl font-bold text-white text-center mb-6" data-id="element-108">
        Daedo Gen 3 Purchase Quote
      </h1>
      <div className="relative" data-id="element-109">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sWnpiiS7hYLBZFWN7s6uPZ/3f11505e-e359-43de-8335-963225ff89d0.png" alt="Daedo Gen 3 Taekwondo Scoring System" className="w-full rounded-lg shadow-xl" data-id="element-110" />
        {/* Hidden indicator for price type - only visible during development */}
        <div className="absolute bottom-2 right-2 bg-black bg-opacity-75 text-white text-xs px-2 py-1 rounded opacity-30" data-id="element-111">
          {currentPriceType === 'wholesale' ? 'Wholesale' : 'Retail'} Pricing
        </div>
      </div>
    </div>;
}